/**
 * AW Embla — shared init helper
 * Initialises an Embla carousel on an element that contains:
 *   .embla__viewport  — the overflow:hidden mask
 *   .embla__container — the flex track
 *   .embla__prev / .embla__next — optional nav buttons
 *
 * Returns the Embla API instance, or null if the viewport isn't found.
 */
function initEmbla(el, options = {}, plugins = []) {
  const viewport = el.querySelector('.embla__viewport');
  if (!viewport || typeof EmblaCarousel === 'undefined') return null;

  const embla = EmblaCarousel(viewport, {
    loop: false,
    align: 'start',
    dragFree: false,
    ...options,
  }, plugins);

  const prevBtn = el.querySelector('.embla__prev');
  const nextBtn = el.querySelector('.embla__next');

  function updateButtons() {
    if (prevBtn) prevBtn.disabled = !embla.canScrollPrev();
    if (nextBtn) nextBtn.disabled = !embla.canScrollNext();
  }

  if (prevBtn) prevBtn.addEventListener('click', () => embla.scrollPrev());
  if (nextBtn) nextBtn.addEventListener('click', () => embla.scrollNext());

  embla.on('init', updateButtons);
  embla.on('select', updateButtons);
  embla.on('reInit', updateButtons);

  return embla;
}